<img
  class="logo"
  src="/assets/icon/logo-blue.svg"
  *transloco="let t"
  [alt]="t('general.homi_logo')"
/>
